import React from "react";

const DashboardDayStats = ({ stats }) => (
  <div
    className="p-4 rounded-4 h-100 d-flex flex-column justify-content-center align-items-center text-center"
    style={{
      background: "linear-gradient(180deg, #ff90ee 0%, #826af6 100%)",
      color: "#fff",
      minHeight: 300,
    }}
  >
    <div className="mb-4">
      <div className="lato-bold-20 mb-1" style={{ color: "#fff" }}>
        Busiest Day
      </div>
      <div
        className="bebas"
        style={{
          fontSize: 32,
          color: "#fff",
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {stats?.busiestDay?.day?.toUpperCase() || "N/A"}
      </div>
    </div>
    <hr
      style={{
        width: "60%",
        border: "none",
        borderTop: "2px solid rgba(255,255,255,0.7)",
        margin: "1.5rem 0",
      }}
    />
    <div>
      <div className="lato-bold-20 mb-1" style={{ color: "#fff" }}>
        Slowest Day
      </div>
      <div
        className="bebas"
        style={{
          fontSize: 32,
          color: "#fff",
          fontWeight: 700,
          letterSpacing: 1,
        }}
      >
        {stats?.slowestDay?.day?.toUpperCase() || "N/A"}
      </div>
    </div>
  </div>
);

export default DashboardDayStats;